export const reportingKeys = {
  root: ['reporting'] as const,
  list: (userId: string, entityId: string) => ['reporting', 'reports', userId, entityId],
  detail: (userId: string, entityId: string, reportId: string) => ['reporting', 'report', userId, entityId, reportId],
  grants: (userId: string, entityId: string, reportId: string) => ['reporting', 'grants', userId, entityId, reportId],
  subscriptions: (userId: string, entityId: string, reportId: string) => ['reporting', 'subscriptions', userId, entityId, reportId],
}

export const queryExplorerKeys = {
  catalog: (userId: string, entityId: string) => ['reporting', 'query-explorer', 'catalog', userId, entityId],
}
